import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { RestaurantProvider } from './contexts/RestaurantContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CarloAgent from './pages/CarloAgent';
import Sales from './pages/Sales';
import Employees from './pages/Employees';
import Events from './pages/Events';
import Tasks from './pages/Tasks';
import Stock from './pages/Stock';
import Setup from './pages/Setup';
import FinancePerformance from './pages/FinancePerformance';
import Products from './pages/Products';
import OrgPanel from './pages/OrgPanel';
import AcceptInvite from './pages/AcceptInvite';
import Register from './pages/Register';
import InviteRegister from './pages/InviteRegister';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

// Create a query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <RestaurantProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/register/invite/:token" element={<InviteRegister />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<ProtectedRoute slug="dashboard"><Dashboard /></ProtectedRoute>} />
              <Route path="/carlo-agent" element={<ProtectedRoute slug="carlo-agent"><CarloAgent /></ProtectedRoute>} />
              <Route path="/sales" element={<ProtectedRoute slug="sales"><Sales /></ProtectedRoute>} />
              <Route path="/inventory" element={<Navigate to="/stock" replace />} />
              <Route path="/employees" element={<ProtectedRoute slug="employees"><Employees /></ProtectedRoute>} />
              <Route path="/events" element={<ProtectedRoute slug="events"><Events /></ProtectedRoute>} />
              <Route path="/tasks" element={<ProtectedRoute slug="tasks"><Tasks /></ProtectedRoute>} />
              <Route path="/stock" element={<ProtectedRoute slug="stock"><Stock /></ProtectedRoute>} />
              <Route path="/orders" element={<Navigate to="/stock?tab=orders" replace />} />
              <Route path="/setup" element={<ProtectedRoute slug="setup"><Setup /></ProtectedRoute>} />
              <Route path="/finance-performance" element={<ProtectedRoute slug="finance-performance"><FinancePerformance /></ProtectedRoute>} />
              <Route path="/products" element={<ProtectedRoute slug="products"><Products /></ProtectedRoute>} />
              <Route path="/org-panel" element={<ProtectedRoute orgAdminOnly><OrgPanel /></ProtectedRoute>} />
              {/* Redirect old routes */}
              <Route path="/organizations" element={<Navigate to="/org-panel" replace />} />
              <Route path="/organization" element={<Navigate to="/org-panel" replace />} />
              <Route path="/invite/:token" element={<AcceptInvite />} />
              {/* Redirects for old routes */}
              <Route path="/integrations" element={<Navigate to="/setup" replace />} />
              <Route path="/revenue" element={<Navigate to="/finance-performance" replace />} />
              <Route path="/finances" element={<Navigate to="/finance-performance" replace />} />
              <Route path="/recipes" element={<Navigate to="/products" replace />} />
              <Route path="/product-analysis" element={<Navigate to="/products" replace />} />
            </Routes>
          </Router>
        </RestaurantProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
}

export default App;
